<footer
  class="hidden md:flex relative items-center py-2 px-1 bg-lightCardBG dark:bg-darkCardBG border-t border-lightMode-300 dark:border-t dark:border-darkMode-700 w-full "
  [class]="global.footerPositionAbsoluteStatus?'absolute z-[1] w-full':''">
  <div class="flex mx-auto 3xl:w-[1300px] 4xl:w-[1550px] w-full items-center">
    <div class="site-prev flex items-center rtl:mr-5 ltr:ml-5">
      <a class="w-6 h-6" [routerLink]="global.jwtService.checkAuth()?'feed':''">
        <img src="assets/image/roshdima.webp" alt="site-logo">
      </a>
      <a [routerLink]="global.jwtService.checkAuth()?'feed':''"
        class="my-auto mx-1 font-semibold text-xs dark:text-darkMode-100"
        (click)="global.scrollTop()">
        رشدیما
      </a>
    </div>
    <div
      class="site-footer-links flex items-center rtl:mr-3 rtl:md:mr-6 ltr:ml-3 ltr:md:md-6">
      <span class="mx-4 text-xs dark:text-darkMode-100">
        ۲۰۲۳©
      </span>
      <a [routerLink]="global.jwtService.checkAuth()?'feed':''"
        class="mx-4 text-xs dark:text-darkMode-100"
        (click)="global.scrollTop()">
        خانه
      </a>
      <a [routerLink]="['/', 'katibe']"
        class="mx-4 text-xs dark:text-darkMode-100"
        (click)="global.scrollTop()">
        کتیبه
      </a>
      <a [routerLink]="['/', 'abzar']"
        class="mx-4 text-xs dark:text-darkMode-100"
        (click)="global.scrollTop()">
        ابزار
      </a>
      <a [routerLink]="['/', 'sanjesh']"
        class="mx-4 text-xs dark:text-darkMode-100"
        (click)="global.scrollTop()">
        سنجش
      </a>
    </div>
  </div>
  <a *ngIf="enamadShow()" referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=523422&Code=sVbbOappC1YAZo99NnG2SelIWpbIpTLZ'>
    <img class="w-16 h-16 ml-16" referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=523422&Code=sVbbOappC1YAZo99NnG2SelIWpbIpTLZ' alt='' style='cursor:pointer' code='sVbbOappC1YAZo99NnG2SelIWpbIpTLZ'>
  </a>
</footer>